export default "__VITE_ASSET__Bed$VMv9__"